import { render, staticRenderFns } from "./CKv.vue?vue&type=template&id=72198b24&"
import script from "./CKv.vue?vue&type=script&lang=js&"
export * from "./CKv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports